import React from 'react';
import MarketingLayout from './MarketingLayout';
import { COLOR } from '../../components/ss/tokens';

const UPDATED = 'June 2026';

const s = {
  wrapper: { maxWidth: 760, margin: '0 auto', padding: '80px 24px 100px', fontFamily: 'Inter, system-ui, sans-serif' },
  h1: { fontSize: 36, fontWeight: 800, color: COLOR.text, marginBottom: 8 },
  meta: { color: COLOR.textMuted, fontSize: 14, marginBottom: 48 },
  h2: { fontSize: 20, fontWeight: 700, color: COLOR.text, marginTop: 40, marginBottom: 10 },
  p: { color: COLOR.textMuted, lineHeight: 1.75, marginBottom: 16, fontSize: 15 },
  ul: { color: COLOR.textMuted, lineHeight: 1.9, paddingLeft: 20, marginBottom: 16, fontSize: 15 },
};

export default function Privacy() {
  return (
    <MarketingLayout title="Privacy Policy — Benevita Home Health Care">
      <div style={s.wrapper}>
        <h1 style={s.h1}>Privacy Policy</h1>
        <p style={s.meta}>Last updated: {UPDATED} &nbsp;·&nbsp; Benevita Home Health Care</p>

        <p style={s.p}>
          Benevita Home Health Care ("we", "our", "Benevita") is committed to protecting the privacy
          and security of your personal and health information. This policy explains what data we
          collect, how we use it, and your rights — in compliance with Kenya's Data Protection Act
          2019, HIPAA principles, and GDPR where applicable.
        </p>

        <h2 style={s.h2}>1. Information We Collect</h2>
        <ul style={s.ul}>
          <li><strong>Identity data:</strong> name, national ID, date of birth, gender</li>
          <li><strong>Contact data:</strong> phone number, email address, home address</li>
          <li><strong>Health data:</strong> medical history, diagnoses, medications, vital signs, visit reports</li>
          <li><strong>Insurance data:</strong> insurer name, policy number, pre-authorisation codes</li>
          <li><strong>Usage data:</strong> browser type, device, pages visited, timestamps (non-identifiable analytics only)</li>
        </ul>

        <h2 style={s.h2}>2. How We Use Your Information</h2>
        <ul style={s.ul}>
          <li>To match you with licensed nurses and coordinate home visits</li>
          <li>To communicate appointment confirmations, reminders, and reports</li>
          <li>To process insurance claims and billing</li>
          <li>To maintain clinical records required by Kenya's health regulations</li>
          <li>To improve the safety and quality of our services</li>
        </ul>

        <h2 style={s.h2}>3. Legal Basis for Processing</h2>
        <p style={s.p}>
          We process health data on the basis of (a) your explicit consent, (b) performance of the
          healthcare contract you enter into with us, and (c) compliance with legal obligations under
          the Health Act, CAP 242, and the Data Protection Act 2019.
        </p>

        <h2 style={s.h2}>4. Sharing Your Information</h2>
        <p style={s.p}>
          We do not sell your personal data. We share your data only with:
        </p>
        <ul style={s.ul}>
          <li>Assigned nurses and doctors involved in your care</li>
          <li>Your insurance provider, with your consent, for claims processing</li>
          <li>Referral partners (e.g., hospitals), where you have authorised a referral</li>
          <li>Regulatory bodies if required by law</li>
        </ul>

        <h2 style={s.h2}>5. Data Retention</h2>
        <p style={s.p}>
          Clinical records are retained for 10 years following your last contact with us, as required
          by Kenyan health regulations. Consent records are kept for 3 years following revocation.
          Audit logs are retained for 7 years.
        </p>

        <h2 style={s.h2}>6. Your Rights</h2>
        <ul style={s.ul}>
          <li><strong>Access:</strong> request a copy of your personal data</li>
          <li><strong>Correction:</strong> request inaccurate data be corrected</li>
          <li><strong>Erasure:</strong> request deletion (subject to clinical record retention obligations)</li>
          <li><strong>Withdrawal of consent:</strong> withdraw marketing or research consent at any time</li>
          <li><strong>Data portability:</strong> receive your data in a structured, readable format</li>
        </ul>
        <p style={s.p}>To exercise any right, email us at <strong>privacy@benevita.co.ke</strong>.</p>

        <h2 style={s.h2}>7. Security</h2>
        <p style={s.p}>
          We use TLS 1.3 encryption in transit, AES-256 encryption at rest, role-based access
          controls, and maintain a full audit trail of all access to health records in compliance
          with HIPAA security principles and ISO 27001.
        </p>

        <h2 style={s.h2}>8. Cookies</h2>
        <p style={s.p}>
          Our public website uses only essential session cookies. We do not use tracking or
          advertising cookies. No personal data is shared with advertising networks.
        </p>

        <h2 style={s.h2}>9. Contact</h2>
        <p style={s.p}>
          Data Protection Officer: <strong>privacy@benevita.co.ke</strong><br />
          Benevita Home Health Care, Nairobi, Kenya
        </p>
      </div>
    </MarketingLayout>
  );
}
